import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchBellNotifications,
  markBellSeen,
  fetchCompanyUsers,
  fetchAllMessages,
  fetchMessageDetail,
  createMessage,
  replyMessage,
  toggleMessageStatus,
} from "services/messages";

export const useBellNotifications = () =>
  useQuery({
    queryKey: ["messages-bell"],
    queryFn: fetchBellNotifications,
    refetchInterval: 30000, // poll every 30 seconds
    staleTime: 10000,
  });

export const useMarkBellSeen = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markBellSeen,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["messages-bell"] });
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },
  });
};

export const useCompanyUsers = () =>
  useQuery({
    queryKey: ["messages-users"],
    queryFn: fetchCompanyUsers,
    staleTime: 5 * 60 * 1000,
  });

export const useAllMessages = (params = {}) =>
  useQuery({
    queryKey: ["messages", params],
    queryFn: () => fetchAllMessages(params),
    staleTime: 10000,
  });

export const useMessageDetail = (id) =>
  useQuery({
    queryKey: ["message", id],
    queryFn: () => fetchMessageDetail(id),
    enabled: !!id,
    staleTime: 0,
  });

export const useCreateMessage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createMessage,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["messages"] });
      queryClient.invalidateQueries({ queryKey: ["messages-bell"] });
    },
  });
};

export const useReplyMessage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => replyMessage(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["message", variables.id] });
      queryClient.invalidateQueries({ queryKey: ["messages"] });
      queryClient.invalidateQueries({ queryKey: ["messages-bell"] });
    },
  });
};

export const useToggleMessageStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => toggleMessageStatus(id),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: ["message", String(id)] });
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },
  });
};
